export let playerVersion: string;

export function setPlayerVersionLogging({playerVersion: _playerVersion}: {playerVersion: string}) {
  playerVersion = _playerVersion;
}
